import request from "@/utils/request.js"

// 关联标签
export const editStoreTags = (formData) => {
    return request.post('/storeTag', formData)
}
